<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>កែប្រែព័ត៌មាន</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100 text-right">
							<span class="red">{{translate(locale.required)}}</span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-80">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h4 class>ព័ត៌មានអំពីភាពយន្ត</h4>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-60">
									<md-field>
										<label>ចំណងជើងភាពយន្ត *</label>
										<md-input type="text" v-model="film.title"></md-input>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-20">
									<md-field>
										<label>ឆ្នាំចេញផ្សាយ *</label>
										<md-input type="number" v-model="film.year"></md-input>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-20">
									<md-field>
										<label>លេខកូដឈុតខ្លីៗ YouTube *</label>
										<md-input type="text" v-model="film.trailer_url"></md-input>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>ការបង្ហាញរឿង *</label>
										<md-select placeholder="ការបង្ហាញរឿង *" v-model="film.visibility">
											<md-option value="all">បង្ហាញទាំងអស់</md-option>
											<md-option value="web">បង្ហាញតែ WEB</md-option>
											<md-option value="mobile">បង្ហាញតែ APP</md-option>
											<md-option value="none">មិនបង្ហាញ</md-option>
										</md-select>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>បណ្តុំរឿង *</label>
										<md-select placeholder="បណ្តុំរឿង *" v-model="film.category_id">
											<md-option :value="category.id"
												v-for="category in categoryList">{{category.name.replace("||",
												",")}}</md-option>
										</md-select>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>ភាសា *</label>
										<md-select placeholder="ភាសា *" v-model="film.language">
											<md-option value="km">ភាសាខ្មែរ</md-option>
											<md-option value="en">ភាសាអង់គ្លេស</md-option>
											<md-option value="th">ភាសាថៃ</md-option>
											<md-option value="cn">ភាសាចិន</md-option>
										</md-select>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>កម្រឹតរូបភាព *</label>
										<md-select placeholder="កម្រឹតរូបភាព *" v-model="film.quality">
											<md-option value="cam">CAM</md-option>
											<md-option value="sd">SD</md-option>
											<md-option value="hd">HD</md-option>
											<md-option value="fhd">FHD</md-option>
										</md-select>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<md-field>
										<label>ការពិពណ៌នា *</label>
										<md-textarea type="text" v-model="film.description"></md-textarea>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<md-field>
										<label>ពាក្យគន្លឹះក្នុងការស្វែងរករឿង *</label>
										<md-textarea type="text" v-model="film.keyword"></md-textarea>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>ប្រភេទរឿង *</label>
										<md-select placeholder="ប្រភេទរឿង *" v-model="film.type">
											<md-option value="movie">ភាពយន្ត</md-option>
											<md-option value="series">រឿងភាគ</md-option>
										</md-select>
									</md-field>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
									<md-field>
										<label>ប្រភេទជាវ *</label>
										<md-select placeholder="ប្រភេទជាវ *" v-model="film.subscription">
											<md-option value="member">សមាជិក</md-option>
											<md-option value="rent">ជួល</md-option>
											<md-option value="free">ឥតគិតថ្លៃ</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25"
									v-if="film.subscription != 'free'">
									<md-field>
										<label>តម្លៃសម្រាប់ជួល *</label>
										<md-input type="number" v-model="film.rent_price"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25"
									v-if="film.subscription == 'rent'">
									<md-field>
										<label>ថ្ងៃដាក់បញ្ចូលជាសមាជិក</label>
										<md-input type="text" v-model="film.rent_end" style="display:none" />
										<datetime type="datetime" v-model="film.rent_end" auto></datetime>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h4>តួអង្គ <br><span class="actor-select" v-for="actor in selected_actor">{{actor.name}} <a @click="removeActor(actor)" class="remove-button"><md-icon>remove</md-icon></a><br></span>
									</h4>
									<div class="md-layout">
										<div class="md-layout-item md-small-size-70 md-size-70">
											<md-field>
												<label>ស្វែងរកតួអង្គដោយឈ្មោះ</label>
												<md-input type="text" v-model="search_actor" @keyup.enter="searchActor()">
												</md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-30 md-size-30">
											<md-button class="md-raised md-primary" @click="searchActor()" style="width: 100%">ស្វែងរក
											</md-button>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100">
											<md-table>
												<md-table-row v-for="(actor, index) in actorList.slice(0, 5)">
													<md-table-cell>
														<img :src="config.cdn + 'images/' + actor.image_url" class="actor-image"> {{actor.name}}
													</md-table-cell>
													<md-table-cell class=" text-right">
														<md-button class="md-just-icon md-simple md-success" @click="addActor(actor)">
															<md-icon>add</md-icon>
															<md-tooltip md-direction="top">ភ្ជាប់តួអង្គនេះ</md-tooltip>
														</md-button>
													</md-table-cell>
												</md-table-row>
											</md-table>
										</div>
									</div>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h4>ដៃគូសហការ {{selected_partner}} 
										<span style="cursor: pointer;" @click="removePartner()" v-if="film.partner_id != ''"><md-icon>remove</md-icon></span>
									</h4>
									<div class="md-layout" v-if="film.partner_id == ''">
										<div class="md-layout-item md-small-size-70 md-size-70">
											<md-field>
												<label>ស្វែងរកដៃគូសហការដោយឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
												<md-input type="text" v-model="search_partner" @keyup.enter="searchPartner()">
												</md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-30 md-size-30">
											<md-button class="md-raised md-primary" @click="searchPartner()" style="width: 100%">ស្វែងរក
											</md-button>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-100">
											<md-table>
												<md-table-row v-for="(partner, index) in partnerList.slice(0, 5)">
													<md-table-cell>
														<b>ID: {{partner.hash}}</b> ({{partner.name}}, {{partner.dividend}}%)
													</md-table-cell>
													<md-table-cell class=" text-right">
														<md-button class="md-just-icon md-simple md-success" @click="addPartner(partner)">
															<md-icon>add</md-icon>
															<md-tooltip md-direction="top">ភ្ជាប់ដៃគូសហការនេះ</md-tooltip>
														</md-button>
													</md-table-cell>
												</md-table-row>
											</md-table>
										</div>
									</div>
								</div>

							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-20">
							<div class="md-layout">
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h4 class>រូបភាព Poster</h4>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<img :src="config.cdn + 'images/' + film.poster_url" class="poster-upload">
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<input type="file" ref="poster" accept="image/png, image/jpeg" @change="handlePoster($event)" style="display: none"/>
									<md-button class="md-raised md-primary" @click="$refs.poster.click()">ផ្ទុករូបភាព</md-button>
								</div>
							</div>
							<div class="md-layout">
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h4 class>រូបភាព Cover</h4>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<img :src="config.cdn + 'images/' + film.cover_url" class="cover-upload">
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<input type="file" ref="cover" accept="image/png, image/jpeg" @change="handleCover($event)" style="display: none"/>
									<md-button class="md-raised md-primary" @click="$refs.cover.click()">ផ្ទុករូបភាព</md-button>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="min-width: 1200px; overflow-x: scroll;" v-if="film.type == 'movie'">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h4 class>វីដេអូ</h4>
									<div class="episode-container">
										<div class="episode-video">
											<input type="file" ref="movie" accept="video/mp4" @change="handleMovie($event)" style="display: none"/>
											<md-button class="md-raised md-primary" style="margin-left: 12px;" @click="$refs.movie.click()"><md-icon>movie</md-icon>ផ្ទុកវីដេអូថ្មី</md-button>
										</div>
										<div style="padding: 12px">
											<md-field>
												<label>រយៈពេល (នាទី)</label>
												<md-input type="text" v-model="film.movie.duration"></md-input>
											</md-field>
										</div>
										<div style="padding: 12px">
											<md-field>
												<label>ការពង្រីក (ភាគរយ)</label>
												<md-input type="text" v-model="film.movie.server_video_padding_percentage"></md-input>
											</md-field>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="!film.movie.uploading && film.movie.original_video_url.length > 0">បានផ្ទុកវីដេអូ</span>
											<span class="red" v-if="!film.movie.uploading && film.movie.original_video_url.length == 0">មិនទាន់មានវីដេអូ</span>
											<span class="yellow" v-if="film.movie.uploading">កំពុងផ្ទុកវីដេអូ {{film.movie.percentage}}%</span>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="film.movie.server_processing_status == 1">{{config.getProcessStatus(film.movie.server_processing_status)}}</span>
											<span class="red" v-if="film.movie.server_processing_status == 0">{{config.getProcessStatus(film.movie.server_processing_status)}}</span>
											<span class="yellow" v-if="film.movie.server_processing_status == 2">{{config.getProcessStatus(film.movie.server_processing_status)}}</span>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="film.movie.status == 1">{{config.getStatus(film.movie.status)}}</span>
											<span class="red" v-if="film.movie.status == 0">{{config.getStatus(film.movie.status)}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="min-width: 1200px; overflow-x: scroll;" v-if="film.type == 'series'">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div style="display: flex; flex-direction: row; align-items: center;">
										<h4 class>វីដេអូ</h4>
										<md-button class="md-just-icon md-simple md-primary" @click="addS()">
											<md-icon>add_circle</md-icon>
											<md-tooltip md-direction="top">បន្ថែម Season</md-tooltip>
										</md-button>
									</div>
								</div>
							</div>
							<div class="md-layout" v-for="(season, s) in film.series">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div style="display: flex; flex-direction: row; align-items: center;">
										<h4>Season {{s+1}}</h4>
										<md-button class="md-just-icon md-simple md-primary" @click="addE(s)">
											<md-icon>add_circle</md-icon>
											<md-tooltip md-direction="top">បន្ថែម Episode</md-tooltip>
										</md-button>
										<md-button class="md-just-icon md-simple md-primary" @click="removeS(s)">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">លុប Season នេះ</md-tooltip>
										</md-button>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(episode, e) in film.series[s]">
									<div class="episode-container">
										<div class="episode-order"><b>{{e+1}}</b></div>
										<div class="episode-video">
											<img :src="config.cdn + 'images/' + film.series[s][e].poster_url" style="width: 128px; height: 72px; margin-right: 10px">

											<input type="file" :ref="'poster' + String(s) + String(e)" accept="image/png, image/jpeg" @change="handleEpisodePoster($event, s, e)" style="display: none"/>
											<md-button class="md-just-icon md-primary" @click="$refs['poster' + String(s) + String(e)][0].click()"><md-icon>image</md-icon><md-tooltip md-direction="top">ផ្លាស់ប្តូររូបភាព</md-tooltip></md-button>

											<input type="file" :ref="'video' + String(s) + String(e)" accept="video/mp4" @change="handleEpisodeVideo($event, s, e)" style="display: none"/>
											<md-button class="md-raised md-primary" style="margin-left: 12px;" @click="$refs['video' + String(s) + String(e)][0].click()"><md-icon>movie</md-icon>ផ្ទុកវីដេអូថ្មី</md-button>
										</div>
										<div style="flex-grow: 1;padding: 12px">
											<md-field>
												<label>ចំណងជើង</label>
												<md-input type="text" v-model="film.series[s][e].title"></md-input>
											</md-field>
										</div>
										<div style="padding: 12px">
											<md-field>
												<label>រយៈពេល (នាទី)</label>
												<md-input type="text" v-model="film.series[s][e].duration"></md-input>
											</md-field>
										</div>
										<div style="padding: 12px">
											<md-field>
												<label>ការពង្រីក (ភាគរយ)</label>
												<md-input type="text" v-model="film.series[s][e].server_video_padding_percentage"></md-input>
											</md-field>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="!film.series[s][e].uploading && film.series[s][e].original_video_url.length > 0">បានផ្ទុកវីដេអូ</span>
											<span class="red" v-if="!film.series[s][e].uploading && film.series[s][e].original_video_url.length == 0">មិនទាន់មានវីដេអូ</span>
											<span class="yellow" v-if="film.series[s][e].uploading">កំពុងផ្ទុកវីដេអូ {{film.series[s][e].percentage}}%</span>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="film.series[s][e].server_processing_status == 1">{{config.getProcessStatus(film.series[s][e].server_processing_status)}}</span>
											<span class="red" v-if="film.series[s][e].server_processing_status == 0">{{config.getProcessStatus(film.series[s][e].server_processing_status)}}</span>
											<span class="yellow" v-if="film.series[s][e].server_processing_status == 2">{{config.getProcessStatus(film.series[s][e].server_processing_status)}}</span>
										</div>
										<div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
											<span class="green" v-if="film.series[s][e].status == 1">{{config.getStatus(film.series[s][e].status)}}</span>
											<span class="red" v-if="film.series[s][e].status == 0">{{config.getStatus(film.series[s][e].status)}}</span>
										</div>
										<div style="padding: 12px; justify-content: center; align-items: center; display: flex;">
											<!-- <md-button class="md-just-icon md-success" style="margin-left: 5px" @click="up(s, e)"><md-icon>arrow_upward</md-icon><md-tooltip md-direction="top">យកទៅលើ</md-tooltip></md-button>
											<md-button class="md-just-icon md-success" style="margin-left: 5px" @click="down(s, e)"><md-icon>arrow_downward</md-icon><md-tooltip md-direction="top">យកចុះក្រោម</md-tooltip></md-button> -->
											<md-button class="md-just-icon md-primary" style="margin-left: 5px" @click="removeE(s, e)"><md-icon>remove</md-icon><md-tooltip md-direction="top">លុបចេញ</md-tooltip></md-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="updateFilm()">កែប្រែ</md-button>
						</div>
					</div>

				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getSettings();
		},
		data() {
			return {
				loaded: false,
				film: {
					title: "",
					description: "",
					keyword: "",
					trailer_url: "",
					poster_url: "image-poster.png",
					cover_url: "image-cover.png",
					type: "",
					subscription: "",
					year: "",
					language: "",
					quality: "",
					visibility: "",
					rent_price: "",
					rent_end: "",
					partner_id : "",
					category_id: "",
					movie: {
						original_video_url: "",
						server_video_padding_percentage: "",
						server_processing_status: 0,
						status: 0,
						duration: "",
						uploading: false,
						percentage: 0
					},
					series: []
				},
				partnerList: [],
				search_partner: "",
				selected_partner: "",
				actorList: [],
				search_actor: "",
				selected_actor: [],
				categoryList: [],
				errors: []
			}
		},
		methods: {
			getFilm() {
				this.$http.get(this.config.api + "/user/film/get/" + this.$route.params.hash).then(data => {
					this.film.title = data.body.data.film.title;
					this.film.description = data.body.data.film.description;
					this.film.keyword = data.body.data.film.keyword;
					this.film.category_id = data.body.data.film.film_category_id;
					this.film.partner_id = data.body.data.film.partner_id;
					this.film.year = data.body.data.film.year;
					this.film.trailer_url = data.body.data.film.trailer_url;
					this.film.poster_url = data.body.data.film.poster_url;
					this.film.cover_url = data.body.data.film.cover_url;
					this.film.type = data.body.data.film.type;
					this.film.subscription = data.body.data.film.subscription;
					this.film.language = data.body.data.film.language;
					this.film.quality = data.body.data.film.quality;
					this.film.visibility = data.body.data.film.visibility;
					this.film.rent_price = data.body.data.film.rental_price;
					this.film.rent_end = data.body.data.film.rental_end;
					this.selected_partner = data.body.data.film.partner_name + " " + data.body.data.film.dividend + "%";
					this.selected_actor = data.body.data.actor;
					if(this.film.type == "movie") {
						this.film.movie.original_video_url = data.body.data.film.original_video_url;
						this.film.movie.server_video_padding_percentage = data.body.data.film.server_video_padding_percentage;
						this.film.movie.server_processing_status = data.body.data.film.server_processing_status;
						this.film.movie.duration = data.body.data.film.duration;
						this.film.movie.status = data.body.data.film.status;
					}
					if(this.film.type == "series") {
						this.film.series = data.body.data.series;
					}
					this.loaded = true;
				})
			},
			searchPartner(more = false) {
				this.$http.post(this.config.api + "/user/partner/search", {
					text: this.search_partner,
				}).then(data => {
					this.partnerList = data.body.data;
				})
			},
			searchActor(more = false) {
				this.$http.post(this.config.api + "/user/actor/search", {
					text: this.search_actor,
				}).then(data => {
					this.actorList = data.body.data;
				})
			},
			getSettings() {
				this.$http.post(this.config.api + "/user/film_category/search", { text: "", size: 100, offset: 0 }).then(data => {
					this.categoryList = data.body.data;
					this.getFilm();
				})
			},
			updateFilm() {
				if (!this.checkValidation()) { return; }

				this.$http.post(this.config.api + "/user/film/update", {
					hash: this.$route.params.hash,
					film: this.film,
					actor: this.selected_actor
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "អ្នកបានកែប្រែភាពយន្តបានដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
						console.log(res.body);
						this.$router.push("/films/detail/" + res.body.data.hash);
					}
				})
			},
			checkValidation() {
				let error = false;

				if (String(this.film.title).length < 3 || String(this.film.year).length < 3 || String(this.film.category_id).length < 1 || String(this.film.language).length < 1 || String(this.film.quality).length < 1 || String(this.film.description).length < 1 || String(this.film.type).length < 1 || String(this.film.subscription).length < 1 || String(this.film.rent_price).length < 1 || String(this.film.poster_url).length < 1 || String(this.film.partner_id).length < 1) error = true;
				if(String(this.film.subscription) == "rent" && String(this.film.rent_end).length < 1) error = true;
			
				if(this.film.type == "movie" && (this.film.movie.original_video_url.length < 1 || String(this.film.movie.duration).length < 1)) error = true;
				if(this.film.type == "series") {
					for(let i =0; i < this.film.series.length; i++) {
						for(let j = 0; j< this.film.series[i].length; j++) {
							if(String(this.film.series[i][j].original_video_url).length < 1 || String(this.film.series[i][j].title).length < 1 || String(this.film.series[i][j].duration).length < 1) {error = true; break;}
						}
					}
				}
				if(error) {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានដែលតម្រូវឱ្យបំពេញទាំងអស់។",
						icon: 'info',
						type: 'danger'
					});
				} else {
					return true;
				}
			},
			handlePoster(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.poster.files[0]);
				this.$http.post(this.config.api + "/user/file/poster", formData).then(res => {
					if (res.body.status == 'success') {
						this.film.poster_url = res.body.data.poster_url;
					}
				})
			},
			handleCover(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.cover.files[0]);
				this.$http.post(this.config.api + "/user/file/cover", formData).then(res => {
					if (res.body.status == 'success') {
						this.film.cover_url = res.body.data.cover_url;
					}
				})
			},
			handleEpisodePoster(event, s, e) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs['poster' + String(s) + String(e)][0].files[0]);
				this.$http.post(this.config.api + "/user/file/video_poster", formData).then(res => {
					if (res.body.status == 'success') {
						this.film.series[s][e].poster_url = res.body.data.poster_url;
					}
				})
			},
			handleEpisodeVideo(event, s, e) {

				if (!event.target.files.length || event.target.files.length == 0) return;
				if(this.$refs['video' + String(s) + String(e)][0].files[0].type != "video/mp4") {
					this.$notification.notify({message: "វីដេអូនេះមិនដំណើរការទេ។", icon: 'info', type: 'danger'});
					return;
				}
				this.film.series[s][e].uploading = true;
				let selectedFile = this.$refs['video' + String(s) + String(e)][0].files[0];
				let original_video_url = this.config.generate(12) + ".mp4";
				const chunkSize = 20 * 1024 * 1024;
				const totalChunks = Math.ceil(selectedFile.size / chunkSize);
				const chunkProgress = 100 / totalChunks;
				let chunkNumber = 0, start = 0, end = start + chunkSize;
				var self = this;

				let uploadChunk = () => {
					if (chunkNumber < totalChunks) {
						const chunk = selectedFile.slice(start, end);
						const formData = new FormData();
						formData.append("file", chunk);
						formData.append("chunkNumber", chunkNumber);
						formData.append("totalChunks", totalChunks);
						formData.append("originalname", original_video_url);

						self.$http.post(self.config.api + "/user/file/video_progressive", formData).then(res => {
							if (res.body.status == 'success') {
								chunkNumber++;
								start = end;
								end = start + chunkSize;
								self.film.series[s][e].percentage = parseInt(chunkNumber * chunkProgress);
								uploadChunk();
							}
						})
					} else {
						self.film.series[s][e].original_video_url = String(original_video_url).replace(".mp4", "");
						self.film.series[s][e].server_processing_status = 0;
						self.film.series[s][e].status = 0;
						self.film.series[s][e].duration = 0;
						self.film.series[s][e].uploading = false;
						self.film.series[s][e].percentage = 0;
					}
				}
				uploadChunk();
				
			},
			handleMovie(event) {

				if (!event.target.files.length || event.target.files.length == 0) return;
				if(this.$refs.movie.files[0].type != "video/mp4") {
					this.$notification.notify({message: "វីដេអូនេះមិនដំណើរការទេ។", icon: 'info', type: 'danger'});
					return;
				}

				this.film.movie.uploading = true;
				let selectedFile = this.$refs.movie.files[0];
				let original_video_url = this.config.generate(12) + ".mp4";
				const chunkSize = 20 * 1024 * 1024;
				const totalChunks = Math.ceil(selectedFile.size / chunkSize);
				const chunkProgress = 100 / totalChunks;
				let chunkNumber = 0, start = 0, end = start + chunkSize;
				var self = this;

				let uploadChunk = () => {
					if (chunkNumber < totalChunks) {
						const chunk = selectedFile.slice(start, end);
						const formData = new FormData();
						formData.append("file", chunk);
						formData.append("chunkNumber", chunkNumber);
						formData.append("totalChunks", totalChunks);
						formData.append("originalname", original_video_url);

						self.$http.post(self.config.api + "/user/file/video_progressive", formData).then(res => {
							if (res.body.status == 'success') {
								chunkNumber++;
								start = end;
								end = start + chunkSize;
								self.film.movie.percentage = parseInt(chunkNumber * chunkProgress);
								uploadChunk();
							}
						})
					} else {
						self.film.movie.original_video_url = String(original_video_url).replace(".mp4", "");
						self.film.movie.server_processing_status = 0;
						self.film.movie.status = 0;
						self.film.movie.duration = 0;
						self.film.movie.uploading = false;
						self.film.movie.percentage = 0;
					}
				}
				uploadChunk();
			},
			addS() {
				this.film.series.push([{ poster_url: "video-cover.png", title: "", duration: "", original_video_url: "", server_video_padding_percentage: "0", server_processing_status: 0, status: 0, uploading: false, percentage: 0 }])
			},
			addE(s) {
				this.film.series[s].push({ poster_url: "video-cover.png", title: "", duration: "", original_video_url: "", server_video_padding_percentage: "0", server_processing_status: 0, status: 0, uploading: false, percentage: 0 })
			},
			up(s, e) {

			},
			down(s, e) {

			},
			removeS(s) {
				if (this.film.series[s].length > 0) {
					this.$notification.notify({
						message: "សូមធ្វើការលុប Episode ជាមុនសិន",
						icon: 'info',
						type: 'danger'
					});
				} else {
					if (this.film.series.length !== 1) {
						this.film.series.splice(s, 1);
					}
				}

			},
			removeE(s, e) {
				this.film.series[s].splice(e, 1);
			},
			addPartner(partner) {
				this.film.partner_id = partner.id;
				this.selected_partner = partner.name + " " + partner.dividend + "%";
			},
			removePartner() {
				this.film.partner_id = "";
				this.selected_partner = "";
			},
			addActor(actor) {
				let existed = false;
				for(let i =0; i < this.selected_actor.length; i++) {
					if(this.selected_actor[i].id == actor.id) existed = true;
				}
				if(!existed) this.selected_actor.push(actor);
			},
			removeActor(actor) {
				console.log(actor);
				for(let i =0; i < this.selected_actor.length; i++) {
					if(this.selected_actor[i].id == actor.id) {
						this.selected_actor.splice(i, 1);
					}
				}
			}
		}
	}
</script>
<style scoped>
	.actor-image {
		width: 60px;
		margin-right: 30px;
	}
	.actor-select {
		margin-left: 16px;
	}
	.remove-button {
		cursor: pointer;
		color: red;
	}
	.poster-upload {
		width: 70%;
		max-width: 300px;
	}
	.cover-upload {
		width: 70%;
		max-width: 300px;
	}
	.episode-container {
		border: 1px solid #F0F0F0; border-radius: 8px; width: 100%; display: flex; flex-direction: row;margin-bottom: 8px; background-color: #FFF;
	}
	.episode-order {
		padding: 12px; justify-content: center; align-items: center; display: flex;
	}
	.episode-video {
		display: flex; flex-direction: row; align-items: center; padding: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Films/Edit.vue